<template>


	<div v-if="loginImageUrl" class="d-flex h-100">
		<div class="position-relative flex-fill" >
		<ChromeHeader/>
			<b-container class="border bg-white shadow text-center p-2 center w-100">
				<!-- <img src="../../../public/img/taTEXT_Logo_v3.png" /> -->
				<img :src='LoginLogoUrl' style="width: 60%;"/>
				<br><br><br>
				<div v-if="reset">
					<h3>Reset HiringCenter Password</h3>
					<b-form @submit.stop.prevent="resetPassword">
						<b-form-group label="Email" label-for="form-email" class="text-left">
							<b-form-input
								id="form-email"
								v-model="form.email"
								type="email"
								required
								placeholder="name@example.com"
							/>
						</b-form-group>
						<p class="text-danger">{{error}}</p>
						<b-button type="submit" variant="primary">Reset</b-button>
					</b-form>
					<small class="pointer" @click="reset = false">Cancel</small>
				</div>
				<div v-else>
					<h3>Log in to HiringCenter</h3>
					<div class="authLogin" v-if="(authlocalStorage == 0)">
						<b-form>
							<b-form-group label="Email" label-for="form-email" class="text-left">
								<b-form-input
									id="form-email"
									v-model="form.email"
									type="email"
									required
									placeholder="name@example.com"
								/>
							</b-form-group>
							<b-form-group label="Password" label-for="form-password" class="text-left">
								<b-form-input
									id="form-password"
									v-model="form.password"
									type="password"
									required
								/>
							</b-form-group>
							<p class="text-danger">{{error}}</p>
							<b-button variant="primary" v-on:click.prevent="submitLogin">Log in</b-button>
						</b-form>
					</div>
					
					<div class="authVerify" v-if="(authlocalStorage == 1)">
						<h6>Please enter the verification code sent to your number {{authLastNumber}}</h6>
						<b-form @submit.prevent="verifyLogin">
							<b-form-group label="Verification Code" label-for="form-otp" class="text-left">
								<b-form-input
									id="form-otp"
									type="text"
									v-model="form.otp"
									required
									placeholder="Enter 6 digit code"
									maxlength="6"
								/>
							</b-form-group>
							<p class="text-danger">{{error}}</p>
							<b-button type="submit" variant="primary">Submit</b-button>
						</b-form>
					</div>
					
					<small v-if="(authlocalStorage == 1)" class="pointer" @click="SendNewVerificationCode()" style="margin-right:10px;">Send new verification code </small>
					
					<small class="pointer" @click="reset = true">Forgot Password?</small>
					<br><br>
					<p>Not a user? <a href="https://RI.link/Consult">Schedule a consult today!</a></p>
				</div>
			</b-container>
		</div>
		<!-- <div v-if="format == 'big'" class="w-40 full-width-img h-100 bg-white overflow-hidden position-relative" >
			<img :src='loginImageUrl' class="h-90 center-horiz" />
		</div> -->
		<!-- <div v-if="format == 'big'" class="w-40 h-100 bg-white overflow-hidden position-relative" >
			<div class="h-10 blue text-white d-flex justify-content-around" >
				<div class="h-100 position-relative" style="width: 11em" >
					<h2 class="center-vert" >Powered by</h2>
				</div>
				<div class="h-100 position-relative" style="width: 260px" >
					<img src="../../../public/img/3P_LOGO_Reversed-big.png" class="h-70 center-vert" />
				</div>
			</div>
			<img src="../../../public/img/Veronica_(VRA).png" class="h-90 center-horiz" />
		</div> -->
	</div>

</template>

<script>
	// import { auth,getAppSettings } from 'src/db.js'
	import { auth } from 'src/db.js'
	import { mapState } from 'vuex'
	import axios from "axios";
	import { db } from 'src/db'
	import moment from 'moment';
	import ChromeHeader from './ChromeHeader.vue';

	export default {
		name: "Login",
		components:{
			ChromeHeader
		},
		props: {
			numberSelected: String
		},
		computed: {
			...mapState('globals', ['format']),
			...mapState("firebase", ["user","extensionuuid","prospects","convos","activeConvo"])
		},
		methods: {
			async SendNewVerificationCode() {
				this.authlocalStorage = 0;
				this.authLastNumber = '';
				localStorage.setItem("authProcess", 0);
				localStorage.setItem("authNumber", '');
				await this.disablePushAuth();
				await auth.signOut();
				this.$store.dispatch('firebase/clearBoundData');
				this.$store.dispatch('globals/CLEAR_ALL');
				this.$router.go(0);
			},
			async disablePushAuth() {
				if (this.fcmToken) {
					this.user.fcmTokens[this.fcmToken] = false; //Machine logged out, do not push
					await db.doc(`Users/${this.user.id}`).set(this.user);
				}
			},
			async submitLogin(evt) {
				try {
					evt.preventDefault()
					await auth.signInWithEmailAndPassword(this.form.email, this.form.password)
					.then(async (confirmationResult) => {
						//eslint-disable-next-line
						console.log("confirmationResult", confirmationResult);
				
						var userDataCollection2 = await this.userDataBefore2FA();
						if(userDataCollection2.hasOwnProperty('Number') && ((userDataCollection2.Number).length > 10)) {

						this.authLastNumber = `***-***-${userDataCollection2.Number.slice(-4)}`;
						localStorage.setItem("authNumber", userDataCollection2.Number);
						
						localStorage.setItem("authProcess", 1);
						this.sendOTPForAuth();
						this.authlocalStorage = 1;
						
						} else {
							this.updateAuthExpTime();
						}

					})
					.catch((error) => {
						//eslint-disable-next-line
						console.log("Error", error);
						this.error = `Incorrect email or password.`;
					});
				} catch(err) {
					this.error = `Incorrect email or password.`;
					this.form.password = null;
				}
			},
			async sendOTPForAuth() {
				
				// var userDataCollection = await this.userDataBefore2FA();
				// this.userTwilioN = userDataCollection.Twilio;
				//eslint-disable-next-line
				// console.log("userDataCollection", userDataCollection.Twilio);

				// localStorage.setItem("authNumber", userDataCollection.Twilio);
				// localStorage.setItem("authNumber", this.userTwilioN);

				//await axios.post("http://localhost:5000/tatext-thirdpool/us-central1/tatext/sendAuthentication", {
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/sendAuthentication", {
					toNumber: localStorage.getItem("authNumber")
				})
				.then(response => {
					//eslint-disable-next-line
					console.log("sendAuthentication res:", response);
					if(response.data.status == 'pending') {
						this.bvToastCommonFn('Verification Code Successfully Sent', 'Success', 'success', 5000);
					}
					if(response.data.status == 429) {
						this.bvToastCommonFn('You have attempted to send the verification code more than 5 times and have reached the limit.', 'Wait for the verification to expire (10min)', 'danger', 10000);
					}
				}).catch(err => {
					//eslint-disable-next-line
					console.log("sendAuthentication err:", err);
				});
				
			},
			async verifyLogin() {
				//await axios.post("http://localhost:5000/tatext-thirdpool/us-central1/tatext/verifyAuthentication", {
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/verifyAuthentication", {
					toNumber: localStorage.getItem("authNumber"),
					codeOTP: this.form.otp
				})
				.then(response => {
					//eslint-disable-next-line
					console.log("verifyAuthentication res:", response);
					if(response.data.status == 'approved') {
						localStorage.setItem("authProcess", 2);
						// UPDATE EXPIRATION TIME
						this.updateAuthExpTime();
						this.bvToastCommonFn('Logged In Successfully', 'Success', 'success', 5000);
					}
					if(response.data.status == 400 || response.data.status == 404 || response.data.status == 'pending') {
						this.form.otp = '';
						this.bvToastCommonFn('You are entering an invalid verification code. Please enter the correct OTP.', 'Invalid Verification Code', 'danger', 10000);
					}
				}).catch(err => {
					//eslint-disable-next-line
					console.log("verifyAuthentication err:", err);
				});
			},
			async resetPassword() {
				try {
					await auth.sendPasswordResetEmail(this.form.email);
				} catch(err) {
					this.error = err;
					return;
				}
				this.reset = false;
				alert("An email has been sent!");
			},
			normalizePhoneNumber1(phoneNumber) {
			// Remove all non-digit characters from the phone number
			const normalizedNumber = phoneNumber.replace(/\D/g, "");
			if (normalizedNumber.startsWith('1')) {
				return normalizedNumber.substring(1);
			}
			return normalizedNumber;
			},
			checkLoginStatus() {
				if (auth.currentUser) {
					//eslint-disable-next-line
					console.log("check",this.extensionuuid);
					this.$router.replace(this.$route.query.redirect || '/chrome');
					// this.$router.replace(this.$route.query.redirect || '/chrome');
					// let checkNum= localStorage.getItem("selectedNumber");
					// //eslint-disable-next-line
					// console.log("checkNum", checkNum);
					// //eslint-disable-next-line
					// console.log("path",this.$route.query.phoneNumber);
					// if(this.$route.query.phoneNumber){
					// 	this.$router.push('/chrome/Conversation');
					// //eslint-disable-next-line
					// console.log("this.convos",this.convos);
					// var num=this.normalizePhoneNumber(this.$route.query.phoneNumber);
					// //eslint-disable-next-line
					// console.log("num",num);
					// // this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
					// let convo = this.convos.filter(convo => {
					// 	this.normalizePhoneNumber(convo.ClientNumber) == num
					// 	//eslint-disable-next-line
					// 	console.log("this.normalizePhoneNumber(convo.ClientNumber)",this.normalizePhoneNumber(convo.ClientNumber));
					// 	}
					// 	); 
					// //eslint-disable-next-line
					// console.log("this.convo",convo);
					// this.$emit('open', convo.id);
					// let prop = this.prospects.find(p => this.normalizePhoneNumber(p.Number) == this.normalizePhoneNumber(this.$route.query.phoneNumber));
					// //eslint-disable-next-line
					// console.log("prop",prop);
					// if(prop){
					// 	// this.extensionuuid=1;
					// 	let convo = this.convos.find(convo => convo.ClientNumber == prop.Number); 
					// 	if(convo){
					// 	this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
					// 	this.$store.dispatch('firebase/bindMessages', convo.id);
					// 	}else{
					// 		this.$store.commit('globals/SET', { var: 'activeConvo', val: null });
					// 		this.$store.dispatch('firebase/bindMessages', null);
					// 	}
					// 	if (this.emails && this.emails.length) {
					// 		let mid = this.getEmailConvoID(prop.id);
					// 		if (mid) {
					// 			this.$store.dispatch('firebase/bindMails', mid);
					// 		}else {
					// 			this.$store.dispatch('firebase/clearonlyMailsData');
					// 		}
					// 	}
					// 	if(this.calls != null && this.calls.length){
					// 		let cid = this.getCallsConvoID(prop.id);
					// 		if (cid){
					// 			this.$store.dispatch('firebase/bindPhones', cid);
					// 		}else {
					// 			this.$store.dispatch('firebase/clearonlyPhonesData');
					// 	}
					// 	}
					// 	this.$store.commit('globals/SET', { var: 'activeProsp', val: prop.id });
					// 	this.$emit('open','pros');
					// }
					// }
			}
			},
			bvToastCommonFn(desc, title, variant, autoHideDelay) {
				this.$bvToast.toast(desc, {
					title: title,
					variant: variant,
					solid: true,
					autoHideDelay: autoHideDelay,
				})
			},
			async userDataBefore2FA() {
				if(auth.currentUser) {
				var userQueryData = await db.collection(`Users`).where("Uid", "==", auth.currentUser.uid).get();
				return userQueryData.docs[0].data();
				}
			},
			// UPDATE EXPIRATION TIME
			async updateAuthExpTime() {
				if(auth.currentUser) {
					var userDataCollection1 = await this.userDataBefore2FA();
					var userPid = userDataCollection1.Pids[0];
					
					// GET NEXT 30 DAYS TIME LOGIC
					const currentDateTime = new Date();
					currentDateTime.setDate(currentDateTime.getDate() + 30);
					var AuthExpiredTime = moment(currentDateTime).valueOf();

					db.doc(`Users/${userPid}`).update({AuthExpired:AuthExpiredTime});

					localStorage.setItem("authSuccess", 1);

					this.checkLoginStatus();
				}
			},
			getQueryParams(url) {
				const params = {};
				const queryString = url.split('?')[1];
				if (queryString) {
				const keyValuePairs = queryString.split('&');
				keyValuePairs.forEach(pair => {
					const [key, value] = pair.split('=');
					params[key] = decodeURIComponent(value);
				});
				}
				return params;
			},
			normalizePhoneNumber(phoneNumber) {
				const normalizedNumber = phoneNumber.replace(/\D/g, "");
				if (normalizedNumber.startsWith('1')) {
					return normalizedNumber.substring(1);
				}
				return normalizedNumber;
			}
			
		},
		data() {
			return {
				form: {
					email: null,
					password: null,
					otp: null,
				},
				reset: false,
				error: null,
				loginImageUrl:'',
				LoginLogoUrl:'',
				// userTwilioN: '+12265462233',
				authlocalStorage: 0, // 0.Init 1.SendOTP 2.Complete
				authLastNumber: '',
			}
		},
		async mounted() {
			if(auth.currentUser) {
				var userDataCollection2 = await this.userDataBefore2FA();
				if(userDataCollection2.hasOwnProperty('Number') && ((userDataCollection2.Number).length > 10)) {
					this.authlocalStorage = localStorage.getItem('authProcess');
					this.authLastNumber = `***-***-${localStorage.getItem('authNumber').slice(-4)}`;
				}
			}
		},
        async created() {
			// Check the URL when the application starts
			const currentURL = window.location.href;
			const queryParams = this.getQueryParams(currentURL);
			if(queryParams.numberSelected){
			//eslint-disable-next-line
			console.log("Current URL:", this.normalizePhoneNumber(queryParams.numberSelected));
			// this.$store.dispatch('firebase/extensionuuid', this.normalizePhoneNumber(queryParams.numberSelected));

			}
			/*
			getAppSettings({
				sid:'1izpGSmYBlUGDSdKIRxa'
			})
			.then((res) => {
				this.loginImageUrl = res.data.LoginImageUrl;
				this.LoginLogoUrl = res.data.LoginLogoUrl;
			})
			.catch(err => alert(`Failure In Getting AppSettings : ${err}`));
			*/
			// this.checkLoginStatus();
			if((localStorage.getItem("authSuccess") === null || localStorage.getItem("authSuccess") == 0)) {
				this.loginImageUrl = 'https://firebasestorage.googleapis.com/v0/b/tatext-thirdpool.appspot.com/o/MeetHiringCenterImage.png?alt=media&token=defd5694-cb1e-4206-adae-e9ae63e57248';
				this.LoginLogoUrl = 'https://firebasestorage.googleapis.com/v0/b/tatext-thirdpool.appspot.com/o/hiringcenterlogo_4.png?alt=media&token=2f4958c4-702c-4687-9a67-fa23589347b4';
			}

			if(auth.currentUser) {
				var userDataCollection2 = await this.userDataBefore2FA();
				// eslint-disable-next-line no-empty
				if(userDataCollection2.hasOwnProperty('Number') && ((userDataCollection2.Number).length > 10)) {
					
				} else {
					//eslint-disable-next-line
					console.log("CREATED ELSE");
					this.checkLoginStatus();
				}
			}

			// IF authProcess Not Set - Initialize Level
			if (localStorage.getItem("authProcess") === null) { localStorage.setItem("authProcess", 0); }
			if (localStorage.getItem("authNumber") === null) { localStorage.setItem("authNumber", ''); }
			if (localStorage.getItem("authSuccess") === null) { localStorage.setItem("authSuccess", 0); }
		}
	}
</script>

<style scoped>

.full-width-img img {
    width: 100%;
    height: 100%;
}
.authVerify h6{
	margin: 20px 0px 0px 0px;
    color: #757575;
}
.center{
	top: 54% !important;
}
@media (min-width: 360px) and (max-width: 640px){
	.center{
		top: 50% !important;
	}
}
</style>